/*********************** Custom JS for Boost AI Search & Discovery  ************************/

(() => {
  const boostRecommendationSelector = '[id^="boost-sd-widget-"]';
  let scheduledFrame = null;

  const restoreThemeSearchDialogs = () => {
    document.querySelectorAll('[data-a11y-boost-suppressed]').forEach((dialog) => {
      const originalModal = dialog.dataset.a11yOriginalAriaModal;
      const originalHidden = dialog.dataset.a11yOriginalAriaHidden;

      if (originalModal === '__missing__') dialog.removeAttribute('aria-modal');
      else dialog.setAttribute('aria-modal', originalModal);

      if (originalHidden === '__missing__') dialog.removeAttribute('aria-hidden');
      else dialog.setAttribute('aria-hidden', originalHidden);

      delete dialog.dataset.a11yOriginalAriaModal;
      delete dialog.dataset.a11yOriginalAriaHidden;
      delete dialog.dataset.a11yBoostSuppressed;
    });

    document.querySelectorAll('[data-a11y-boost-dialog]').forEach((dialog) => {
      const attributes = {
        role: dialog.dataset.a11yOriginalRole,
        'aria-modal': dialog.dataset.a11yOriginalModal,
        'aria-label': dialog.dataset.a11yOriginalLabel
      };
      Object.entries(attributes).forEach(([name, value]) => {
        if (value === '__missing__') dialog.removeAttribute(name);
        else dialog.setAttribute(name, value);
      });
      delete dialog.dataset.a11yOriginalRole;
      delete dialog.dataset.a11yOriginalModal;
      delete dialog.dataset.a11yOriginalLabel;
      delete dialog.dataset.a11yBoostDialog;
    });
  };

  const syncBoostInstantSearchDialog = () => {
    const activeInput = document.activeElement?.closest?.('.boost-sd__search-widget-init-input');
    const input = activeInput?.getAttribute('aria-expanded') === 'true'
      ? activeInput
      : Array.from(document.querySelectorAll('.boost-sd__search-widget-init-input[aria-expanded="true"]'))
        .find((candidate) => candidate.offsetParent !== null);

    if (!input) {
      restoreThemeSearchDialogs();
      return;
    }

    const boostDialog = input.closest('#boost-sd__instant-search-container') || input.closest('#bc-instant-search');
    if (!boostDialog) return;

    if (!boostDialog.hasAttribute('data-a11y-boost-dialog')) {
      boostDialog.dataset.a11yOriginalRole = boostDialog.hasAttribute('role') ? boostDialog.getAttribute('role') : '__missing__';
      boostDialog.dataset.a11yOriginalModal = boostDialog.hasAttribute('aria-modal') ? boostDialog.getAttribute('aria-modal') : '__missing__';
      boostDialog.dataset.a11yOriginalLabel = boostDialog.hasAttribute('aria-label') ? boostDialog.getAttribute('aria-label') : '__missing__';
    }
    boostDialog.setAttribute('role', 'dialog');
    boostDialog.setAttribute('aria-modal', 'true');
    boostDialog.setAttribute('aria-label', input.getAttribute('placeholder') || 'Search our store');
    boostDialog.dataset.a11yBoostDialog = 'true';

    document.querySelectorAll('.search-modal.modal__content[role="dialog"]').forEach((dialog) => {
      if (dialog.contains(input) || dialog.hasAttribute('data-a11y-boost-suppressed')) return;
      dialog.dataset.a11yOriginalAriaModal = dialog.hasAttribute('aria-modal') ? dialog.getAttribute('aria-modal') : '__missing__';
      dialog.dataset.a11yOriginalAriaHidden = dialog.hasAttribute('aria-hidden') ? dialog.getAttribute('aria-hidden') : '__missing__';
      dialog.removeAttribute('aria-modal');
      dialog.setAttribute('aria-hidden', 'true');
      dialog.dataset.a11yBoostSuppressed = 'true';
    });
  };

  const enhanceRecommendationCarousels = () => {
    document.querySelectorAll(boostRecommendationSelector).forEach((root) => {
      root.querySelectorAll('.slick-dots').forEach((pagination) => {
        pagination.setAttribute('aria-label', 'Recommendation carousel pagination');

        const buttons = Array.from(pagination.querySelectorAll('button'));
        buttons.forEach((button, index) => {
          button.setAttribute('aria-label', `Go to recommendation slide ${index + 1} of ${buttons.length}`);

          if (button.closest('li')?.classList.contains('slick-active')) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      });

      root.querySelectorAll('.boost-sd__prev-button-icon').forEach((icon) => {
        icon.closest('button')?.setAttribute('aria-label', 'Previous recommendation slide');
      });
      root.querySelectorAll('.boost-sd__next-button-icon').forEach((icon) => {
        icon.closest('button')?.setAttribute('aria-label', 'Next recommendation slide');
      });
    });
  };

  const repairBoostRelationships = () => {
    if (typeof document.querySelector !== 'function' || typeof document.getElementById !== 'function') return;

    const mobileFilters = document.querySelector('#boost-sd_filter-tree-mobile');
    if (mobileFilters) {
      const referenceAttributes = ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-owns'];
      mobileFilters.querySelectorAll('[id]').forEach((element, index) => {
        const originalId = element.getAttribute('id');
        if (!originalId || document.querySelectorAll(`[id="${CSS.escape(originalId)}"]`).length < 2) return;

        let uniqueId = `${originalId}--mobile`;
        let suffix = index;
        while (document.getElementById(uniqueId)) uniqueId = `${originalId}--mobile-${suffix++}`;
        element.setAttribute('id', uniqueId);

        mobileFilters.querySelectorAll(referenceAttributes.map((attribute) => `[${attribute}]`).join(',')).forEach((candidate) => {
          referenceAttributes.forEach((attribute) => {
            const value = candidate.getAttribute(attribute);
            if (!value) return;
            const tokens = value.split(/\s+/).map((token) => token === originalId ? uniqueId : token);
            candidate.setAttribute(attribute, tokens.join(' '));
          });
        });
      });
    }

    document.querySelectorAll('.boost-sd__search-form-input[aria-owns], .boost-sd__search-widget-init-input[aria-owns]').forEach((input) => {
      const ownedIds = input.getAttribute('aria-owns')?.split(/\s+/).filter(Boolean) || [];
      if (ownedIds.some((id) => !document.getElementById(id))) input.removeAttribute('aria-owns');
    });
  };

  const scheduleEnhancement = () => {
    if (scheduledFrame !== null) return;
    scheduledFrame = requestAnimationFrame(() => {
      scheduledFrame = null;
      enhanceRecommendationCarousels();
      syncBoostInstantSearchDialog();
      repairBoostRelationships();
    });
  };

  const start = () => {
    scheduleEnhancement();
    document.addEventListener('focusin', scheduleEnhancement);
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') setTimeout(scheduleEnhancement);
    });
    new MutationObserver(scheduleEnhancement).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-expanded']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
